
import { Grid } from "@mui/material";
import '..//App.css';
import Image from "../images/audience.jpg"

export default function TopBanner(props) {


    return (
        <Grid container direction="column" justifyContent="center"
            sx={{ height: "300px", backgroundPosition: "0% 70%", backgroundSize: "cover", backgroundImage: `url(${Image})` }}>

            <Grid container justifyContent="center" >
                
            </Grid>

        </Grid>)
};

